import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'
import { IdeaStatus } from '../interfaces'

import TopicMetadata from './TopicMetadata'
import TopicPills from './TopicPills'
import TopicTitle from './TopicTitle'

export interface TopicInfoProps {
  title: string
  contentType: ContentType
  publicId: string
  trashed: boolean
  spam: boolean
  publishedAt: string
  replyCount: number
  views: number
  publicLabel: string | null
  votes?: number
  likes?: number
  category?: string
  forum?: string
  ideationStatus?: IdeaStatus
  pending: boolean
  destinationUrl: string
  sticky: boolean
  hasBestAnswer: boolean
  // onUpdate: (categoryId: number) => void
}

class TopicInfo extends PureComponent<TopicInfoProps> {
  render() {
    const {
      title,
      contentType,
      publicId,
      trashed,
      spam,
      ideationStatus,
      publicLabel,
      replyCount,
      views,
      publishedAt,
      votes,
      likes,
      pending,
      sticky,
      hasBestAnswer,
      destinationUrl,
      category,
      forum
    } = this.props
    return (
      <section id='topic-moderation--topic-info'>
        <TopicPills
          trashed={trashed}
          spam={spam}
          ideationStatus={ideationStatus}
          publicLabel={publicLabel}
          pending={pending}
          sticky={sticky}
          hasBestAnswer={hasBestAnswer}
        />
        <TopicTitle title={title} contentType={contentType} publicId={publicId} destinationUrl={destinationUrl} />
        <TopicMetadata
          publishedAt={publishedAt}
          replyCount={replyCount}
          views={views}
          votes={votes}
          likes={likes}
          category={category}
          forum={forum}
        />
      </section>
    )
  }
}

export default TopicInfo
